import React, { FC } from 'react';

import { Icons, SvgIcon } from '../../shared/components/SvgIcon';
import { Theme, Typography, styled } from '@material-ui/core';
import { SectionBookType } from 'src/config/api/models/Book';

type BookCoverImageProps = {
  image: string;
  large?: boolean;
  className?: string;
  topCornersRound?: boolean;
  altText?: string;
  bookType?: SectionBookType;
};
interface WrapperProps {
  isPreview: boolean;
}

const Wrapper = styled('div')<Theme, WrapperProps>(({ theme, isPreview }) => ({
  position: 'relative',
  background: theme.palette.grey['100'],
  overflow: 'hidden',
  lineHeight: 0,
  fontSize: 0,
  '&.large': {
    borderBottomLeftRadius: '1.5rem',
    borderBottomRightRadius: '1.5rem',
  },
  '&.topCornersRound': {
    borderTopLeftRadius: '1.5rem',
    borderTopRightRadius: '1.5rem',
  },
  ...(isPreview && {
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(180deg, #006B8A 0%, rgba(0, 107, 138, 0) 100%)',
      zIndex: 2,
    },
  }),
}));

const BookCoverPlaceholder = styled('div')({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
});

const Image = styled('img')({
  width: '100%',
  height: '100%',
  position: 'relative',
  aspectRatio: '2/3',
  objectFit: 'cover',
  objectPosition: 'center',
});

const StyledImageBanner = styled('div')({
  height: '35px',
  width: '50%',
  backgroundColor: '#EC6523',
  position: 'absolute',
  zIndex: 10,
  right: 0,
  top: '20px',
  color: '#FFFFFF',
  '&:before': {
    content: '""',
    display: 'inline-block',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '17.5px 0 17.5px 10px',
    borderColor: '#EC6523 #EC6523 #EC6523 transparent',
    position: 'absolute',
    top: '0',
    right: '100%',
  },
});

const StyledImageBannerDiv = styled('div')({
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
});

const BookCoverImage: FC<BookCoverImageProps> = ({
  large,
  image,
  className,
  altText,
  topCornersRound = false,
  bookType,
}) => {
  const src =
    image && image.match(/^http[s]?:\/\/.*/)
      ? image
      : `${process.env.REACT_APP_STORAGE_ROOT}/${image}`;

  return (
    <Wrapper
      className={`${className} ${large ? 'large' : ''} ${topCornersRound ? 'topCornersRound' : ''}`}
      isPreview={bookType === 'preview_book'}
    >
      {bookType === 'preview_book' && (
        <StyledImageBanner>
          <StyledImageBannerDiv>
            <Typography style={{ fontWeight: 700 }} variant="h3">
              INKIJKEN
            </Typography>
          </StyledImageBannerDiv>
        </StyledImageBanner>
      )}

      {src ? (
        <Image src={src} loading="lazy" alt={altText} />
      ) : (
        <BookCoverPlaceholder>
          <SvgIcon icon={Icons.BOOK} large />
        </BookCoverPlaceholder>
      )}
    </Wrapper>
  );
};

export { BookCoverImage };
